(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  if (typeof jQuery !== "undefined" && jQuery('.slick-slider').length) {
    jQuery('.slick-slider').slick({
      slidesToShow: 4,  // Desktop shows 4 slides
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  }

  // Read More toggle
  jQuery('.read-more-toggle').on('click', function(){
    var snippet = jQuery(this).prev('.review-snippet');
    var shortText = snippet.data('short');
    var fullText = snippet.data('full');

    if(jQuery(this).attr('aria-expanded') === 'false'){
      snippet.text(fullText);
      jQuery(this).text('Read Less');
      jQuery(this).attr('aria-expanded', 'true');
    } else {
      snippet.text(shortText);
      jQuery(this).text('Read More');
      jQuery(this).attr('aria-expanded', 'false');
    }
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamond-tab-selector"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".diamond-tab");
  const contents = document.querySelectorAll(".diamond-tab-content");

  function deactivateAll() {
    tabs.forEach(tab => tab.classList.remove("active"));
    contents.forEach(content => content.classList.remove("active"));
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const targetId = tab.getAttribute("data-tab-id");
      deactivateAll();
      tab.classList.add("active");
      document.getElementById(targetId).classList.add("active");
    });
  });

  // Activate first tab by default
  if (tabs.length) {
    tabs[0].click();
  }
});


  } catch(e) { console.error(e); }
})();
})();
